<form class="authorize-payment-bank-account-form" novalidate [formGroup]="paymentForm">
  <h3 class="authorize-payment-form-table__title">Payment method</h3>
  <cpds-radio-group
    [options]="radioOptions"
    groupName="newBankAccount"
    formControlName="newBankAccount"
  ></cpds-radio-group>
  <cpds-alert [intent]="alertIntent.INFO" *ngIf="paymentForm.get('newBankAccount').value === 'true'">
    We’ll replace your current payment information with the information you enter below. All fields are required.
  </cpds-alert>
  <div
    class="formElem"
    [ngClass]="{ 'has-error': paymentForm.get('accountNumber').touched && !paymentForm.get('accountNumber').valid }"
  >
    <div id="account-number" class="form__field">
      <basic-text-input
        #accountNumberInput
        *ngIf="paymentForm.get('newBankAccount').value === 'true'"
        [propertyName]="'accountNumber'"
        [placeholder]="'Account number'"
        (valueChanged)="validateAN()"
        (onBlur)="validateAN()"
        [parserType]="'Text'"
        [inputType]="'text'"
        type="text"
        formControlName="accountNumber"
        [formGroupComponent]="true"
      ></basic-text-input>
    </div>
  </div>
  <div
    class="formElem"
    [ngClass]="{ 'has-error': paymentForm.get('routingNumber').touched && !paymentForm.get('routingNumber').valid }"
  >
    <div id="routing-number" class="form__field">
      <basic-text-input
        #routingNumberInput
        *ngIf="paymentForm.get('newBankAccount').value === 'true'"
        [propertyName]="'routingNumber'"
        [placeholder]="'Routing number'"
        (valueChanged)="validateRN()"
        (onBlur)="validateRN()"
        [parserType]="'Text'"
        [inputType]="'text'"
        type="text"
        [maxlength]="9"
        formControlName="routingNumber"
        [formGroupComponent]="true"
      ></basic-text-input>
    </div>
  </div>
  <div class="formElem">
    <div id="account-type">
      <select-basic
        #accountTypeSelect
        *ngIf="paymentForm.get('newBankAccount').value === 'true'"
        [propertyName]="'accountTypeComponent'"
        [label]="'Account Type'"
        [optionValues]="accountTypeOptions"
        (onBlur)="validateAccountType()"
        formControlName="accountType"
        [formGroupComponent]="true"
      ></select-basic>
    </div>
  </div>
  <hr
    class="authorize-payment-form-table__divider"
    *ngIf="hasPaymentFailed && paymentForm.get('newBankAccount').value !== 'true'"
  />
  <div class="authorization-detail" *ngIf="hasPaymentFailed && paymentForm.get('newBankAccount').value === 'true'">
    <div class="authorization-detail-text">
      I, {{ payerName }}, authorize the Massachusetts Mutual Life Insurance Company ("the Company") to debit
      {{ totalPremium }} on {{ isAnnualPayment ? 'an annual' : 'a monthly' }} basis beginning on {{ authorizationDate }}
      from my financial institution via Electronic Funds Transfer (EFT). This authorization will remain in effect until
      the Company receives notification of termination. I may revoke this authorization by emailing
      <a class="authorize-payment-form-table__text-link" href="mailto:DigitalCustomerSupport@massmutual.com"
        >DigitalCustomerSupport@massmutual.com</a
      >
      or calling
      <a class="authorize-payment-form-table__text-link" href="tel:1-866-618-7797">1-866-618-7797</a>
      .
    </div>
    <div class="authorization-detail-terms">
      <a href="/common/pdf/{{ termsPDF }}" target="_blank"> Premium Payment Service Terms &amp; Conditions </a>
    </div>
  </div>
  <div class="authorization-text" *ngIf="!hasPaymentFailed">
    <cpds-checkbox formControlName="paymentAuthorized" error="This is Required." description=""
      >I authorize the Massachusetts Mutual Life Insurance Company to complete a one-time debit of the above amount from
      my bank account above via electronic funds transfer (EFT). I understand this is not a recurring debit and I will
      need to provide authorization annually.</cpds-checkbox
    >
  </div>
</form>
<div class="cta">
  <button cpdsButton (click)="submit()" [disabled]="isDisabled()">Authorize payment</button>
  <button cpdsButton (click)="cancel()" [variant]="'tertiary'">Cancel</button>
</div>
<div *ngIf="isInvalidPaymentInfo()">
  <cpds-alert intent="danger">
    <span>{{ paymentInfoError }} </span>
  </cpds-alert>
</div>
